import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import api from '../services/api';
import API_URL from '../config';

const SuccessPayment = () => {
  const [bookingDetails, setBookingDetails] = useState(null);
  const [roomName, setRoomName] = useState('');
  const [message, setMessage] = useState('');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  useEffect(() => {
    const fetchBookingDetails = async () => {
      const bookingId = searchParams.get('bookingId');
      if (!bookingId) {
        setMessage('Aucune réservation trouvée.');
        return;
      }
      
      try {
        // Fetch booking details
        const response = await api.get(`${API_URL}/api/bookings/${bookingId}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        setBookingDetails(response.data);

        // Fetch room details based on roomId from the booking
        const roomResponse = await api.get(`${API_URL}/api/rooms/${response.data.roomId}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        setRoomName(roomResponse.data.name);
      } catch (error) {
        setMessage('Erreur lors de la récupération des détails de la réservation.');
        console.error(error);
      }
    };
    
    fetchBookingDetails();
  }, [searchParams]);

  const formatDate = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);

    const dateFormatted = start.toLocaleDateString('fr-FR', {
      weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'
    });

    const startTimeFormatted = start.toLocaleTimeString('fr-FR', {
      hour: '2-digit', minute: '2-digit'
    });

    const endTimeFormatted = end.toLocaleTimeString('fr-FR', {
      hour: '2-digit', minute: '2-digit'
    });

    return `${dateFormatted}, de ${startTimeFormatted} à ${endTimeFormatted}`;
  };

  const getRoomDisplayName = (name, soloOrGroup) => {
    if (name === 'Grande') {
      return `Grande salle (${soloOrGroup === 'Group' ? 'en groupe' : 'en solo'})`;
    } else if (name === 'Petite') {
      return 'Petite salle';
    } else {
      return name;
    }
  };

  const handleReturnToBookings = () => {
    navigate('/bookings');
  };

  return (
    <div style={{ backgroundColor: '#f0f0f0', padding: '20px', textAlign: 'center' }}>
      <h2>Félicitations !</h2>
      {message && <p>{message}</p>}
      {bookingDetails ? (
        <div>
          <p>Votre réservation est confirmée. En voici les détails :</p>
          <p><strong>Sélection :</strong> {getRoomDisplayName(roomName, bookingDetails.soloOrGroup)}</p>
          <p><strong>Date :</strong> {formatDate(bookingDetails.startTime, bookingDetails.endTime)}</p>
              <p><strong>   </strong> </p>
		  <p><strong>Numéro de réservation :</strong> <strong>{bookingDetails.reservationNumber}</strong></p>
		    <p><strong>   </strong> </p>
		    <p><strong> Veuillez apporter avec vous ce numéro de réservation SVP </strong> </p>
		  <p> (il vous a été aussi été envoyé par e-mail et vous pouvez le retrouver dans vos réservations) </p>
		  
          <button onClick={handleReturnToBookings}> Voir mes réservations</button>
		    <p><strong>   </strong> </p>
		  
        </div>
      ) : (
        <p>Chargement des détails de la réservation...</p>
      )}
    </div>
  );
};

export default SuccessPayment;